/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    SearchSubRuleListItem,
    SearchSubRuleListItemFromJSON,
    SearchSubRuleListItemFromJSONTyped,
    SearchSubRuleListItemToJSON,
} from './';

/**
 * 
 * @export
 * @interface SearchSubRuleListItemPaginationWrapper
 */
export interface SearchSubRuleListItemPaginationWrapper {
    /**
     * 
     * @type {Array<SearchSubRuleListItem>}
     * @memberof SearchSubRuleListItemPaginationWrapper
     */
    items?: Array<SearchSubRuleListItem> | null;
    /**
     * 
     * @type {number}
     * @memberof SearchSubRuleListItemPaginationWrapper
     */
    totalItems?: number;
}

export function SearchSubRuleListItemPaginationWrapperFromJSON(json: any): SearchSubRuleListItemPaginationWrapper {
    return SearchSubRuleListItemPaginationWrapperFromJSONTyped(json, false);
}

export function SearchSubRuleListItemPaginationWrapperFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchSubRuleListItemPaginationWrapper {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': !exists(json, 'items') ? undefined : (json['items'] === null ? null : (json['items'] as Array<any>).map(SearchSubRuleListItemFromJSON)),
        'totalItems': !exists(json, 'totalItems') ? undefined : json['totalItems'],
    };
}

export function SearchSubRuleListItemPaginationWrapperToJSON(value?: SearchSubRuleListItemPaginationWrapper | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': value.items === undefined ? undefined : (value.items === null ? null : (value.items as Array<any>).map(SearchSubRuleListItemToJSON)),
        'totalItems': value.totalItems,
    };
}


